'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<g id="icons/account/projects-icon-library-55736" fill="none" fill-rule="evenodd"><g id="icons/account/projects-account-55736" transform="translate(-25 -511)"><g id="icons/account/projects-icons/account/projects-55736" transform="translate(25 510)"><mask id="icons/account/projects-mask-2-55736" fill="#fff"><path d="M20 9.18l-9 1.8-9-1.8V7h18v2.18zM20 19H2v-7.78l8 1.6V15c0 .55.45 1 1 1s1-.45 1-1v-2.18l8-1.6V19zM9 4c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1H9V4zm12 1h-6V4c0-1.65-1.35-3-3-3h-2C8.34 1 7 2.35 7 4v1H1c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h20c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z" id="icons/account/projects-path-1-0-55736"/></mask><g id="icons/account/projects-color-/-18.-black_000000-55736" mask="url(#icons/account/projects-mask-2-55736)" fill="#000"><path id="icons/account/projects-black_000000-55736" d="M0 0h22v22H0z"/></g></g></g></g><!-- Filename: sourceSvg/account/projects.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 20'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};